import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as EmployeeActions from '../_actions/employee';
import { Employee } from '../_models';

export interface EmployeeState extends EntityState<Employee> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Employee> = createEntityAdapter<Employee>();

const initialState: EmployeeState = adapter.getInitialState({
  loading: false,
  error: null,
});

const employeeReducer = createReducer(
  initialState,

  on(EmployeeActions.loadEmployees, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EmployeeActions.loadEmployeesSuccess, (state, { employees }) =>
    adapter.setAll(employees, { ...state, loading: false })
  ),

  on(EmployeeActions.loadEmployeesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EmployeeActions.addEmployeeSuccess, (state, { employee }) => adapter.addOne(employee, state)),

  on(EmployeeActions.updateEmployeeSuccess, (state, { employee }) =>
    adapter.upsertOne(employee, state)
  ),

  on(EmployeeActions.deleteEmployeeSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    EmployeeActions.addEmployeeFailure,
    EmployeeActions.updateEmployeeFailure,
    EmployeeActions.deleteEmployeeFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: EmployeeState | undefined, action: Action) {
  return employeeReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
